<script setup>
// Small CRM stage badge shown on a conversation list row when the conversation has a deal.
import { useConversationBadge } from '../useConversationBadge';

const props = defineProps({
  conversationId: { type: [Number, String], default: null },
});
const badge = useConversationBadge(() => props.conversationId);
</script>

<template>
  <span
    v-if="badge"
    v-tooltip="`${badge.pipeline_name} · ${badge.stage_name}`"
    class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[0.625rem] font-medium max-w-[9rem]"
    :style="{
      backgroundColor: `${badge.stage_color}22`,
      color: badge.stage_color,
    }"
  >
    <span
      class="rounded-full size-1.5 shrink-0"
      :style="{ backgroundColor: badge.stage_color }"
    />
    <span class="truncate">{{ badge.stage_name }}</span>
  </span>
</template>
